import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLHtmlElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLHtmlElement
 */
export default class HTMLHtmlElement extends HTMLElement {}
